/**
 * Column Control with Responsive Options
 */
import { RangeControl, TabPanel } from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { i18n } from 'cartzillagb'

const ColumnControl = props => {
	const {
		onChangexs,
		onChangesm,
		onChangemd,
		onChangelg,
		onChangexl,
		xsColumns = undefined,
		smColumns = undefined,
		mdColumns = undefined,
		lgColumns = undefined,
		xlColumns = undefined,
		xsMin = 1,
		xsMax = 2,
		smMin = 1,
		smMax = 4,
		mdMin = 1,
		mdMax = 6,
		lgMin = 1,
		lgMax = 8,
		xlMin = 1,
		xlMax = 8,
		label = 'Columns',
	} = props

	const tabProps = {
		'xl': {
			output: () => {
				return (
					<RangeControl
						label={ label }
						value={ xlColumns }
						onChange={ onChangexl }
						min={ xlMin }
						max={ xlMax }
						help={ __( 'Extra Large ( ≥1200px )', i18n ) }
					/>
				)
			}
		},
		'lg': {
			output: () => {
				return (
					<RangeControl
						label={ label }
						value={ lgColumns }
						onChange={ onChangelg }
						min={ lgMin }
						max={ lgMax }
						help={ __( 'Large Screen ( <1200px )', i18n ) }
					/>
				)
			}
		},
		'md': {
			output: () => {
				return (
					<RangeControl
						label={ label }
						value={ mdColumns }
						onChange={ onChangemd }
						min={ mdMin }
						max={ mdMax }
						help={ __( 'Medium Screen ( <992px )', i18n ) }
					/>
				)
			}
		},
		'sm': {
			output: () => {
				return (
					<RangeControl
						label={ label }
						value={ smColumns }
						onChange={ onChangesm }
						min={ smMin }
						max={ smMax }
						help={ __( 'Small Screen ( <768px )', i18n ) }
					/>
				)
			}
		},
		'xs': {
			output: () => {
				return (
					<RangeControl
						label={ label }
						value={ xsColumns }
						onChange={ onChangexs }
						min={ xsMin }
						max={ xsMax }
						help={ __( 'Extra Small < 576px', i18n ) }
					/>
				)
			}
		},
	}

	const tabs = [
		... xlColumns ? [ {
			name: "xl",
			title: __( 'xl', i18n ),
			className: "czgb-xl-tab",
		} ] : [],
		... lgColumns ? [ {
			name: "lg",
			title: __( 'lg', i18n ),
			className: "czgb-lg-tab",
		} ] : [],
		... mdColumns ? [ {
			name: "md",
			title: __( 'md', i18n ),
			className: "czgb-md-tab",
		} ] : [],
		... smColumns ? [ {
			name: "sm",
			title: __( 'sm', i18n ),
			className: "czgb-sm-tab",
		} ] : [],
		... xsColumns ? [ {
			name: "xs",
			title: __( 'xs', i18n ),
			className: "czgb-xs-tab",
		} ] : [],
	]

	if( tabs.length < 1 ) {
		return null
	}

	return (
		<TabPanel className="czgb-columns-tab-panel czgb-size-type-field-tabs czgb-without-size-type" activeClass="active-tab" tabs={ tabs }>
			{
				tab => {
					const selectedTab = tabProps[ `${ tab.name }`]
					const tabout = selectedTab.output()

					return <div className="czgb-size-type__tab-content">{ tabout }</div>
				}
			}
		</TabPanel>
	)
}

export default ColumnControl